// Without this the formatters below silently invent dates: new Date(null) and
// new Date(0) are the Unix epoch and render as 01.01.1970, while "", " " and
// undefined give an Invalid Date and render as NaN.NaN.NaN. " " is the "no
// date" sentinel used all over this project, so both cases are common.
const isUsableDate = (date) => {
  if (date === null || date === undefined || date === 0 || date === "0")
    return false;
  return !isNaN(new Date(date).getTime());
};

const dateFormatter = (date) => {
  if (!isUsableDate(date)) return "-";
  const d = new Date(date);
  const day = ("0" + d.getDate()).slice(-2);
  const month = ("0" + (d.getMonth() + 1)).slice(-2);
  const year = d.getFullYear();
  return day + "." + month + "." + year;
};

const dateTimeFormatter = (date) => {
  if (!isUsableDate(date)) return "-";
  const d = new Date(date);
  const hours = ("0" + d.getHours()).slice(-2);
  const minutes = ("0" + d.getMinutes()).slice(-2);
  return hours + ":" + minutes;
};

const addDays = (date, days, noWeekends) => {
  // returns date after days added
  // if noWeekends, next Monday after days added is returned
  let result = new Date(date);
  result.setDate(result.getDate() + days);
  if (noWeekends) {
    if (result.getDay() === 0) {
      result.setDate(result.getDate() + 1);
    }
    if (result.getDay() === 6) {
      result.setDate(result.getDate() + 2);
    }
  }
  return result;
};

function formatDateToYYYYMMDD(date) {
  // formats a date to: YYYY-MM-DD
  // "" and not "-": the result feeds <input type="date">, which only accepts an
  // empty string or a real YYYY-MM-DD value.
  if (!isUsableDate(date)) return "";
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

const getWeekDayName = (date) => {
  // Unguarded this returned "Thursday" for null — the epoch really was one.
  if (!isUsableDate(date)) return "";
  const d = new Date(date);
  const weekday = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  return weekday[d.getDay()];
};

export {
  dateFormatter,
  formatDateToYYYYMMDD,
  dateTimeFormatter,
  addDays,
  getWeekDayName,
};
